// AIDEV-NOTE: Resolve os limites de desconto efetivos do wizard.
// Precedencia: limite especial do cliente (politicas_cliente, via busca de clientes)
// SEMPRE substitui a politica do vendedor e libera desconto p/ vendedor sem permissao.
// Mantem paridade com o validador server-side (desconto.validator.ts).

export interface PoliticasDescontoUser {
  pode_dar_desconto_item?: boolean;
  limite_desconto_item?: number;
  pode_dar_desconto_total?: boolean;
  limite_desconto_total?: number;
}

export interface LimitesDesconto {
  podeDescontoItem: boolean;
  limiteDescontoItem: number;
  podeDescontoTotal: boolean;
  limiteDescontoTotal: number;
}

export function resolverLimitesDesconto(
  politicas: PoliticasDescontoUser | null | undefined,
  limiteEspecialCliente: number | null
): LimitesDesconto {
  if (limiteEspecialCliente !== null) {
    return {
      podeDescontoItem: true,
      limiteDescontoItem: limiteEspecialCliente,
      podeDescontoTotal: true,
      limiteDescontoTotal: limiteEspecialCliente
    };
  }
  // AIDEV-NOTE: Defaults permissivos (true/100) — paridade com o comportamento
  // anterior do Step3 quando o claim nao esta presente no JWT.
  return {
    podeDescontoItem: politicas?.pode_dar_desconto_item ?? true,
    limiteDescontoItem: politicas?.limite_desconto_item ?? 100,
    podeDescontoTotal: politicas?.pode_dar_desconto_total ?? true,
    limiteDescontoTotal: politicas?.limite_desconto_total ?? 100
  };
}
